import { render } from "./TabQuickSearch.vue?vue&type=template&id=f444bd60&scoped=true"
import script from "./TabQuickSearch.vue?vue&type=script&lang=js"
export * from "./TabQuickSearch.vue?vue&type=script&lang=js"

import "./TabQuickSearch.vue?vue&type=style&index=0&id=f444bd60&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f444bd60"

export default script